export const LIGHT_BLUE = "#4F60D2";